export default __webpack_public_path__ + "static/health-int-wearable-d5b65ef872f7b6b49833dae221906483.png";